import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import DailySpecial from "../DealComponents/DailySpecial/DailySpecial";
import LunchSpecial from "../DealComponents/LunchSpecial/LunchSpecial";
import HappyHours from "../DealComponents/HappyHours/HappyHours";

function BDealList() {
  const { businessId } = useParams();
  const [activeTab, setActiveTab] = useState("daily");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // Inline style for active tab
  const getTabClass = (tab) => {
    return activeTab === tab ? "active" : "";
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <h2 className="card-title mb-0">Deals for Business</h2>
              </CardHeader>
              <CardBody>
                {/* Tabs */}
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={getTabClass("daily")}
                      onClick={() => toggleTab("daily")}
                      style={{ cursor: "pointer" }}
                    >
                      Daily Special
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={getTabClass("lunch")}
                      onClick={() => toggleTab("lunch")}
                      style={{ cursor: "pointer" }}
                    >
                      Lunch Special
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={getTabClass("happy")}
                      onClick={() => toggleTab("happy")}
                      style={{ cursor: "pointer" }}
                    >
                      Happy Hours
                    </NavLink>
                  </NavItem>
                </Nav>

                <div className="mt-3">
                  {activeTab === "daily" && <DailySpecial businessId={businessId} />}
                  {activeTab === "lunch" && <LunchSpecial businessId={businessId} />}
                  {activeTab === "happy" && <HappyHours businessId={businessId} />}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BDealList;
